export const EVENT_EMITTER_EVENT_STOP = "stop";

enum PlayerStatus {
  INIT,
  CONNECTING,
  CONNECTED,
  PLAYING,
  PAUSED,
  RECONNECTING,
  EXITING,
  DISCONNECTED,
}
export { PlayerStatus };
